import { HazardBaseLayer } from "./HazardBaseLayer";
import {
  getHazardLayerProps,
  type HazardLayerConfig,
} from "@/features/map/utils/hazardLayerUtils";

interface Props {
  year: number;
  defaultVisible: boolean;
  visible?: boolean;
}

const host = process.env.VITE_HAZARD_TILE_HOST ?? "";

// 下記の文字列は年を分けるラジオボタンのグループの識別でも使われるため、特殊な変な文字を使わないでください
export const FLOOD_10_LAYER_NAME = "洪水浸水想定区域（計画規模）";

const layerConfig: HazardLayerConfig = {
  // leafletが管理するレイヤー名（実際のleafletレイヤー名はここに年度サフィックスを付加したもの）
  layerName: FLOOD_10_LAYER_NAME,
  yearConfigs: {
    2023: {
      url: `${host}/10/flood_10.pmtiles`,
      dataLayer: "4326_merged",
    },
    2024: {
      url: `${host}/10/2024_flood_10.pmtiles`,
      dataLayer: "2024_flood_10",
    },
    // 将来 2025年などが増えた場合はここに行を追加する
  },
};

const colorMap: Record<number, string> = {
  1: "rgb(246,246,172)",
  2: "rgb(254,218,194)",
  3: "rgb(255,187,186)",
  4: "rgb(255,152,151)",
  5: "rgb(244,139,205)",
  6: "rgb(222,128,222)",
};
const attributeKey = "A31b_101";

/*
洪水浸水想定区域（計画規模）レイヤー
タイル元データ: 洪水浸水想定区域データ（1次メッシュ単位）2023年度, 2024年度
https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A31b-2023.html
https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A31b-2024.html
*/
export const HazardFlood10Layer: React.FC<Props> = ({
  defaultVisible,
  year,
  visible,
}) => {
  const layerProps = getHazardLayerProps(year, layerConfig);
  if (layerProps) {
    const { url, layerName, dataLayer } = layerProps;
    return (
      <HazardBaseLayer
        defaultVisible={defaultVisible}
        layerName={layerName}
        dataLayer={dataLayer}
        url={url}
        attributeKey={attributeKey}
        colorMap={colorMap}
        visible={visible}
      />
    );
  }
  return null;
};
